import { ReactNode, useCallback, useState } from "react";
import { NavLink } from "react-router";
import t from "@/lang/lang";
import {
  SampleBaseDataTableFilters,
  useDefaultSampleBaseDataListRequest,
} from "@/services/backend/samples/components/sample-base-data-table";
import { WaterBaseDataTable } from "@/services/backend/samples/components/water-base-data-table";
import { CreateWaterBaseDataDialog } from "@/services/backend/samples/components/create-water-base-data-dialog";
import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";

export function WaterBaseDataListRoute() {
  const [request, setRequest] = useState(useDefaultSampleBaseDataListRequest());

  const renderRowLink = useCallback(
    (baseDataId: string, children: ReactNode) => (
      <NavLink to={baseDataId}>{children}</NavLink>
    ),
    [],
  );

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Wasserproben")}</CardTitle>
        <CardDescription>
          {t(
            "Hier können Sie die Vorgabewerte verwalten, mit denen eine neue Wasserprobe angelegt wird. Die als aktiv markierten Basisdaten werden dafür verwendet.",
          )}
        </CardDescription>
        <CardAction>
          <CreateWaterBaseDataDialog />
        </CardAction>
      </CardHeader>
      <CardContent className="grid gap-2">
        <SampleBaseDataTableFilters
          request={request}
          onRequestChange={setRequest}
        />
        <WaterBaseDataTable
          request={request}
          onRequestChange={setRequest}
          renderRowLink={renderRowLink}
          hideBorder
        />
      </CardContent>
    </Card>
  );
}
